import { Button, Input, MagellanPopup } from 'components/atoms';
import RoleSelectCard from 'components/molecules/card/role-select/RoleSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { ARTIST_ROLE } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IArtistRoleSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectArtistRoles?: (roles: ARTIST_ROLE[], actions: PopupActions) => void;
  open?: boolean;
  initialRoles?: ARTIST_ROLE[];
}

const ArtistRoleSelectPopupForm = ({
  trigger,
  onSelectArtistRoles,
  open,
  initialRoles = [],
}: IArtistRoleSelectPopupFormProps) => {
  const [params, setParams] = useSearchParams();
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [roleSearch, setRoleSearch] = useState('');
  const [roles, setRoles] = useState<ARTIST_ROLE[]>(initialRoles);

  // useEffect(() => {
  //   setRoles(initialRoles);
  // }, [initialRoles]);

  return (
    <Popup
      ref={popupRef}
      open={open}
      // onOpen={() => {
      //   setOpen(true);
      // }}
      onClose={() => {
        setParams({});
        setRoles([]);
        setRoleSearch('');
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('button.add-artist-to-release')}</MagellanPopup.Header>

        <Input.Text
          value={roleSearch}
          onChange={(e) => setRoleSearch(e.target.value)}
          name=""
          appBackground
          placeholder={t('input.placeholder.search-role')}
        />
        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {Object.values(ARTIST_ROLE)
            .filter((role) => typeof role === 'string' && role !== 'unknown')
            .filter((role) =>
              t(`artist-role.${role}.name`).toLowerCase().includes(roleSearch.toLowerCase()),
            )
            .map((role) => {
              const convertedRole = ARTIST_ROLE[role as keyof typeof ARTIST_ROLE];
              return (
                <RoleSelectCard
                key={convertedRole}
                  role={convertedRole}
                  isSelected={roles.includes(convertedRole)}
                  onClick={(newRole) =>
                    setRoles((prev) =>
                      prev.includes(newRole)
                        ? prev.filter((prevRole) => prevRole !== newRole)
                        : [...prev, newRole],
                    )
                  }
                  disabled={
                    (convertedRole === ARTIST_ROLE.mainArtist &&
                      roles.includes(ARTIST_ROLE.featuredArtist)) ||
                    (convertedRole === ARTIST_ROLE.featuredArtist &&
                      roles.includes(ARTIST_ROLE.mainArtist))
                  }
                />
              );
            })}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            disabled={!roles.length}
            onClick={() =>
              popupRef.current &&
              onSelectArtistRoles &&
              onSelectArtistRoles(roles, popupRef.current)
            }
          >
            <Button.Text text={t('button.add-to-release')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default ArtistRoleSelectPopupForm;
